import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  applicantReferencesKey,
  deleteApplicantReferencesRoute,
  errorMessage,
} from '@features/applicant';
import axiosInstance from '@server/axiosInstance';

type UseDeleteApplicantReferenceProps = {
  applicantId?: number;
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const useDeleteApplicantReference = ({
  setErrorText,
  applicantId,
}: UseDeleteApplicantReferenceProps) => {
  const client = useQueryClient();

  const {
    mutate: deleteApplicantReference,
    isLoading: isDeleteApplicantReferenceLoading,
  } = useMutation({
    mutationFn: (variables: { reference_id: number }) =>
      axiosInstance
        .post(deleteApplicantReferencesRoute, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        setErrorText('');
        client.invalidateQueries([applicantReferencesKey, applicantId]);
      }
    },
    onError: (error: { message?: string }) => {
      setErrorText(error?.message || errorMessage);
    },
  });

  return {
    deleteApplicantReference,
    isDeleteApplicantReferenceLoading,
  };
};
